/** Parte visível do elemento dentro da viewport (px). */
export function visibleHeightInViewport(
  top: number,
  bottom: number,
  viewportHeight: number,
): number {
  return Math.max(0, Math.min(bottom, viewportHeight) - Math.max(top, 0));
}

/**
 * Espelha o threshold do IntersectionObserver (~12% do elemento visível).
 * Usado para revelar conteúdo ao saltar para âncoras (#secção).
 */
export function shouldRevealInViewport(
  top: number,
  bottom: number,
  elementHeight: number,
  viewportHeight: number,
): boolean {
  const visible = visibleHeightInViewport(top, bottom, viewportHeight);
  const threshold = Math.min(Math.max(elementHeight, 1) * 0.12, viewportHeight * 0.12);
  return visible >= threshold;
}
